import React, { createContext, useContext, useState } from "react";

const DataContext = createContext();


export const DataProvider = ({ children }) => {
  const [dataset, setDataset] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [sideBarDataset, setSideBarDataset] = useState([]);

  const contextValue = {
    dataset,
    setDataset,
    userInfo,
    setUserInfo,
    sideBarDataset,
    setSideBarDataset,
  };

  return (
    <DataContext.Provider value={contextValue}>
      {children}
    </DataContext.Provider>
  );
};
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
